let loader = null;

export const loadRazorpay = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (!loader) {
    loader = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => { loader = null; resolve(false); };
      document.body.appendChild(s);
    });
  }
  return loader;
};

// Opens Razorpay Checkout; resolves with the payment response, or null if the customer closes it.
export const openRazorpay = ({ rz, user, shopName }) =>
  new Promise((resolve) => {
    const rp = new window.Razorpay({
      key: rz.key_id,
      amount: rz.amount,
      currency: rz.currency,
      order_id: rz.order_id,
      name: "STACK",
      description: `Order from ${shopName}`,
      prefill: { name: user?.name || "", email: user?.email || "", contact: user?.phone || "" },
      theme: { color: "#059669" },
      handler: (resp) => resolve(resp),
      modal: { ondismiss: () => resolve(null) },
    });
    rp.open();
  });
